import { TURN_OFF_DEAL_TEMPLATES_VIEW, TURN_ON_DEAL_TEMPLATES_VIEW } from '../actionTypes/initActionTypes';

export const turnOffTemplateView = () => ({
    type: TURN_OFF_DEAL_TEMPLATES_VIEW
});

export const turnOnTemplateView = () => ({
    type: TURN_ON_DEAL_TEMPLATES_VIEW
});
